export const environment = {
  production: false,
  line_client_id: 1660820508,
  line_redirect_url: 'https://seller-dev-cbs.pages.dev/login',
  line_client_secret: '171f4dd6e1b81dfe7ad8e958c89d8e32',
  backend_url: 'https://cbs-connect-accchula-dev.azurewebsites.net/api/',
  terms_and_condition: 'https://drive.google.com/file/d/1zr2o2bKELZ72GETbrcl3czF03FdAO8lZ/view',
  privacy_policy: 'https://drive.google.com/file/d/1GujUba1SCg1GMFOyahyWHrsMkOq3JyUY/view',
};
  